export { embedCreateRequestRoute, embedSinglePortalRoute, embedKBArticleRoute } from './routes';
